import PropTypes from 'prop-types';
import * as S from './styled';
import CardsListItem from './CardsListItem';

const CardsList = ({
  cards,
  cardsStats,
  cardsEstimates,
  liveWorklogs,
  isLabelExpanded,
  onClickExpandLabel,
  getWhoisTracking,
}) => {
  return (
    <S.CardsList>
      {cards.map((card) => (
        <CardsListItem
          key={card.id}
          card={card}
          estimates={cardsEstimates.filter((item) => item.cardId === card.id)}
          totalTime={cardsStats[card.id] || null}
          liveWorklogs={liveWorklogs}
          isLabelExpanded={isLabelExpanded}
          onClickExpandLabel={onClickExpandLabel}
          getWhoisTracking={getWhoisTracking}
        />
      ))}
    </S.CardsList>
  );
};

CardsList.defaultProps = {
  cardsStats: {},
  cardsEstimates: [],
};

CardsList.propTypes = {
  cards: PropTypes.array.isRequired,
  cardsStats: PropTypes.object,
  cardsEstimates: PropTypes.array,
  isLabelExpanded: PropTypes.bool.isRequired,
  onClickExpandLabel: PropTypes.func.isRequired,
  getWhoisTracking: PropTypes.func,
};

export default CardsList;
